// extracted by mini-css-extract-plugin
export default {"fileDrop":"styles_fileDrop__kgdBr"};